import { Button, Flex, Modal } from "antd";
import React from "react";
import Title from "antd/es/typography/Title";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { baseRouteMaker, routes } from "../../../../../constants/routeConsts";
import { CustomTitle } from "../../../../common/customTitle";
import { colors } from "../../../../../constants/colors";
import styles from "./SignIn.module.scss";

const AgeVerficationModal = ({ open, onClose,sendData }) => {
  /* translation dependencies */
  const { t } = useTranslation();
  /* translation dependencies */

  /* navigation dependencies */
  const navigate = useNavigate();
  /* navigation dependencies */

  const handleSubmit=()=>{
    onClose()
    sendData()
  }

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={false}
      className={styles.ageVerificationContainer}
      closeIcon={true}
    >
      <Flex
        vertical
        gap="2rem"
        align="center"
        justify="center"
        style={{ padding: "30px 0px" }}
      >
        {/* <CustomTitle
          justifyContent="center"
          style={{ color: colors.primaryColor }}
        >
          {t("confirmationPopup.ageVerificationText")}
        </CustomTitle> */}
        <Title level={3} type="secondary" style={{ textAlign: "center" }}>
          {t("CommonUtils.fifteenMinuteMessage")}
        </Title>

        {/* <Title level={2} style={{ margin: 0 }}>
          {t("confirmationPopup.confirmationAgeText")}
        </Title> */}

        <Flex gap="0.8rem">
          <Button
            type="primary"
            onClick={()=>handleSubmit()}
            className={styles.buttonStyle}
          >
            {t("CommonUtils.okay")}
          </Button>

          {/* <Button
            type="default"
            className={styles.buttonStyle}
            onClick={() => onClose()}
          >
            {t("confirmationPopup.buttonNoText")}
          </Button> */}
        </Flex>
      </Flex>
    </Modal>
  );
};

export default AgeVerficationModal;
